{
  "Poll_Viewer_VoteCount_Modal_Voters_Private_Voter": "Private User",
  "Poll_Viewer_ShowAllOptions_CTA": "Lihat Semua Pilihan",
  "Spoiler_Reveal_Tooltip": "Klik untuk mendedahkan",
  "VerticalEmbed_Event_Error_Subtitle": "This event has been deleted, replace it with another event.",
  "Viewer_Toolbar_Twitter_Tooltip": "'Tweet' ini",
  "CollapsibleListPlugin_CollapseButton_AriaLabel": "Item dilipat",
  "Spoiler_Reveal_Video_CTA": "Dedahkan Video",
  "VerticalEmbed_Pricing_Plan": "Plan only",
  "Image_Expand_Button_AriaLabel": "Kembangkan imej",
  "VerticalEmbed_From_Price": "From",
  "Poll_Viewer_ShowAllResults_CTA": "Lihat Semua Keputusan",
  "Spoiler_Reveal_Image_Placeholder": "Imej ini mengandungi spoiler",
  "VerticalEmbed_Ribbon": "Sale",
  "Audio_Plugin_Elapsed_Time_Slider_AriaLabel": "Cari peluncur",
  "VerticalEmbed_Error_Subtitle": "This item has been deleted, replace it with another item.",
  "Poll_Viewer_Multiselect_Footer": "Anda boleh mengundi lebih daripada satu jawapan.",
  "Audio_Plugin_More_Actions_Button_AriaLabel": "Tunjukkan lebih banyak kawalan audio",
  "VerticalEmbed_Booking_Fetch_Error_Title": "Failed to load service",
  "Fullscreen_Close_Button_AriaLabel": "Tutup",
  "VerticalEmbed_Event_Fetch_Error_Title": "Failed to load event",
  "UploadFile_Viewer_Loader": "Memuatkan {{fileType}}",
  "Polls_Plugin_User_Avatar_Alt": "User avatar",
  "Preview_ReadMore_Label": "Baca lebih lanjut",
  "Spoiler_Insert_Tooltip": "Spoiler",
  "VerticalEmbed_Product_Fetch_Error_Title": "Failed to load product",
  "Fullscreen_Shrink_Button_AriaLabel": "Shrink",
  "Audio_Plugin_Volume_Control_Slider_AriaLabel": "Kelantangan",
  "Spoiler_Reveal_Gallery_Placeholder": "Galeri ini mengandungi spoiler",
  "Fullscreen_Expand_Button_AriaLabel": "Expand",
  "VerticalEmbed_Bookings_Button": "Tempah Sekarang",
  "Audio_Plugin_Volume_Control_Unmute_AriaLabel": "Nyahbisukan",
  "Spoiler_Reveal_Gallery_CTA": "Dedahkan Galeri",
  "Poll_Viewer_ShowLess_CTA": "Tunjukkan kurang",
  "VerticalEmbed_Disabled_Button_Tooltip": "Product page will be available once you publish your site.",
  "Audio_Plugin_Volume_Control_Mute_AriaLabel": "Bisukan",
  "Poll_Viewer_VoteCount_Modal_Voters_Anonymous": "+{{anonNumber}} tanpa nama",
  "Poll_Viewer_VoteCount_Modal_Voters_CTA_Follow": "Ikut",
  "VerticalEmbed_Products_Button": "Beli Sekarang",
  "Poll_Viewer_Toast_Error_ServerDown": "Tidak dapat menyambung ke pelayan. Cuba lagi kemudian.",
  "Poll_Viewer_VoteCount_Modal_Voters_Header": "{{count}} individu telah mengundi jawapan ini",
  "Poll_Viewer_VoteCount": "{{number}} undian",
  "VerticalEmbed_Events_Button": "Daftar Sekarang",
  "Spoiler_Reveal_Image_CTA": "Dedahkan Imej",
  "Poll_Viewer_Toast_Error_Connection": "Tanpa internet. Semak sambungan anda.",
  "Poll_Viewer_Visibility_Owner_Footer": "Hanya anda yang dapat melihat keputusannya.",
  "VerticalEmbed_Booking_Error_Title": "Service deleted",
  "VerticalEmbed_Product_Error_Title": "Product deleted",
  "VerticalEmbed_Fetch_Error_Subtitle": "Unable to load item information.",
  "Poll_Viewer_VoteCount_Modal_Voters_Header_plural": "{{count}} orang telah mengundi jawapan ini",
  "VerticalEmbed_Event_Error_Title": "Event deleted",
  "CollapsibleListPlugin_ExpandButton_AriaLabel": "Item dikembangkan",
  "Audio_Plugin_Cover_Alt": "Audio cover",
  "Spoiler_Reveal_Video_Placeholder": "Video ini mengadungi spoiler",
  "VerticalEmbed_Product_Fetch_Error_Subtitle": "Unable to load product information.",
  "VerticalEmbed_Fetch_Error_Title": "Failed to load item",
  "Poll_Viewer_Option_AriaLabel_Unchecked": "unchecked",
  "VerticalEmbed_Product_Error_Subtitle": "This product has been deleted, replace it with another product.",
  "VerticalEmbed_Booking_Error_Subtitle": "This service has been deleted, replace it with another service.",
  "Preview_SeeFullPost_Label": "Lihat siaran penuh",
  "UploadFile_Viewer_Download": "Muat turun {{fileType}}",
  "VerticalEmbed_Units_Hour": "{{jam}}j",
  "VerticalEmbed_Units_Minute": "{{minit}}min",
  "VerticalEmbed_Event_Fetch_Error_Subtitle": "Unable to load event information.",
  "VerticalEmbed_Error_Button": "Replace",
  "VerticalEmbed_Error_Title": "Item deleted",
  "VerticalEmbed_Booking_Fetch_Error_Subtitle": "Unable to load service information.",
  "Poll_Viewer_Option_AriaLabel_Checked": "checked"
}
